import React, {FC, memo} from "react";
import './GridAreaContentLayoutCheckbox.css'

const GridAreaContentLayoutCheckboxComponent: FC<{
  id: string,
  checked: boolean,
  setChecked: (value: boolean) => void,
  label: string,
}> = ({
  id,
  checked,
  setChecked,
  label,
}) => {

  return (
    <label className="grid-area-content-layout-checkbox-container" htmlFor={id}>
      <input
        className="grid-area-content-layout-checkbox"
        checked={checked}
        onChange={() => setChecked(!checked)}
        type="checkbox"
        id={id}
      />
      <span className="grid-area-content-layout-checkbox-checkmark"></span>
      <span className="grid-area-content-layout-checkbox-label">{label}</span>
    </label>
  )
}

export const GridAreaContentLayoutCheckbox = memo(GridAreaContentLayoutCheckboxComponent)